// extracted by mini-css-extract-plugin
export default {"container":"NativeHeader_container__4+dpC","item":"NativeHeader_item__rqsGJ"};